import { render, staticRenderFns } from "./_register.vue?vue&type=template&id=7087f21e&scoped=true&lang=pug&"
import script from "./_register.vue?vue&type=script&lang=js&"
export * from "./_register.vue?vue&type=script&lang=js&"
import style0 from "./_register.vue?vue&type=style&index=0&id=7087f21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087f21e",
  null
  
)

export default component.exports